export default __webpack_public_path__ + "static/Spaceship-dda2ede36b932e1f6c2e2e7a534e4b77.svg";